import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GridLoader from 'react-spinners/GridLoader';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './routes/Home';

/**
 * El home viaja en el bundle inicial porque es la primera pantalla que ve
 * cualquier visitante. Las páginas internas se cargan bajo demanda, así la
 * carga inicial no arrastra el peso de todo el sitio.
 */
const About = lazy(() => import('./routes/About'));
const Services = lazy(() => import('./routes/Services'));
const Contact = lazy(() => import('./routes/Contact'));
const NotFound = lazy(() => import('./routes/NotFound'));

/**
 * Spinner que se muestra mientras baja el chunk de una página interna.
 *
 * Antes este spinner corría con un setTimeout de 800 ms fijo en cada visita:
 * retrasaba el sitio sin estar esperando nada. Ahora está atado a una carga
 * real, así que aparece solo cuando de verdad hay algo pendiente.
 */
const PageLoader = () => (
  <div className="spinner">
    <GridLoader color="rgb(241, 165, 1)" size={50} />
  </div>
);

const App = () => (
  <div className="app">
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          {/* Cualquier URL desconocida cae aquí en lugar de dejar la página en
              blanco, que era lo que pasaba antes. */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </BrowserRouter>
  </div>
);

export default App;
